import { useState } from 'react'
import { supabase } from '../supabase'
import { useNavigate, Link } from 'react-router-dom'

const NAVY  = '#0B1F3A'
const TEAL  = '#2DD4B0'
const MUTED = '#6B7280'
const BORDER= '#E5E7EB'
const BG    = '#F8FAFC'

const inp = {
  width: '100%', border: '1.5px solid ' + BORDER, borderRadius: '10px',
  padding: '11px 14px', fontSize: '14px', outline: 'none',
  fontFamily: 'Space Grotesk, -apple-system, sans-serif',
  color: '#111827', background: '#fff', boxSizing: 'border-box',
  transition: 'border-color 0.15s',
}

function ForgotPassword() {
  const navigate = useNavigate()
  const [email, setEmail]     = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent]       = useState(false)
  const [error, setError]     = useState('')

  const handleSubmit = async () => {
    if (!email) { setError('Please enter your email address'); return }
    if (!email.includes('@')) { setError('Please enter a valid email address'); return }
    setLoading(true); setError('')
    const { error: err } = await supabase.auth.resetPasswordForEmail(email.trim().toLowerCase(), {
      redirectTo: 'https://app.pageconnect.io/reset-password',
    })
    if (err) { setError(err.message); setLoading(false) }
    else { setSent(true); setLoading(false) }
  }

  return (
    <div style={{ minHeight: '100vh', background: BG, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', fontFamily: 'Space Grotesk, -apple-system, sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: '20px', width: '100%', maxWidth: '400px', overflow: 'hidden', boxShadow: '0 8px 40px rgba(11,31,58,0.12)', border: '1px solid ' + BORDER }}>

        {/* Header */}
        <div style={{ background: NAVY, padding: '28px 32px', textAlign: 'center' }}>
          <div style={{ fontSize: '22px', fontWeight: 800, color: '#fff', letterSpacing: '-0.5px', marginBottom: '4px' }}>PageConnect</div>
          <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>Reset your password</div>
        </div>

        <div style={{ padding: '32px' }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              {/* SVG envelope icon */}
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(45,212,176,0.1)', border: '2px solid rgba(45,212,176,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div style={{ fontSize: '20px', fontWeight: 800, color: '#111827', marginBottom: '8px' }}>Check your email</div>
              <div style={{ fontSize: '13px', color: MUTED, marginBottom: '4px', lineHeight: 1.6 }}>We sent a reset link to</div>
              <div style={{ fontSize: '14px', fontWeight: 700, color: NAVY, marginBottom: '24px' }}>{email}</div>
              <div style={{ background: BG, borderRadius: '12px', padding: '14px 16px', marginBottom: '24px', fontSize: '12.5px', color: MUTED, lineHeight: 1.8, textAlign: 'left' }}>
                {['Click the link in the email to reset your password', 'The link expires in 1 hour', 'Check your spam folder if you don\'t see it'].map((t, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2.5" strokeLinecap="round" style={{ flexShrink: 0 }}><polyline points="20 6 9 17 4 12"/></svg>
                    {t}
                  </div>
                ))}
              </div>
              <button onClick={() => navigate('/login')}
                style={{ width: '100%', padding: '13px', borderRadius: '12px', background: NAVY, border: 'none', fontSize: '14px', fontWeight: 700, color: '#fff', cursor: 'pointer', fontFamily: 'inherit', marginBottom: '10px' }}>
                Back to login
              </button>
              <button onClick={() => { setSent(false); setError('') }}
                style={{ width: '100%', padding: '11px', borderRadius: '12px', border: '1px solid ' + BORDER, background: '#fff', fontSize: '13px', fontWeight: 600, color: MUTED, cursor: 'pointer', fontFamily: 'inherit' }}>
                Try a different email
              </button>
            </div>
          ) : (
            <>
              <div style={{ fontSize: '20px', fontWeight: 800, color: '#111827', marginBottom: '6px' }}>Forgot your password?</div>
              <div style={{ fontSize: '13px', color: MUTED, marginBottom: '24px', lineHeight: 1.6 }}>
                Enter your email and we'll send you a link to reset it.
              </div>

              {error && (
                <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', color: '#DC2626', fontSize: '12.5px', borderRadius: '10px', padding: '10px 12px', marginBottom: '16px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0, marginTop: '1px' }}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  {error}
                </div>
              )}

              <div style={{ marginBottom: '16px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: MUTED, display: 'block', marginBottom: '6px' }}>Email address</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                  placeholder="your@email.com" autoFocus style={inp}
                  onFocus={e => e.target.style.borderColor = TEAL}
                  onBlur={e => e.target.style.borderColor = BORDER} />
              </div>

              <button onClick={handleSubmit} disabled={loading}
                style={{ width: '100%', padding: '13px', borderRadius: '12px', background: loading ? BORDER : NAVY, border: 'none', fontSize: '14px', fontWeight: 700, color: loading ? '#9CA3AF' : '#fff', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', marginBottom: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                {loading && <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', animation: 'fp-spin 0.7s linear infinite' }} />}
                {loading ? 'Sending...' : 'Send reset link'}
              </button>

              <div style={{ textAlign: 'center', fontSize: '13px', color: MUTED }}>
                <Link to="/login" style={{ color: NAVY, fontWeight: 600, textDecoration: 'none' }}>← Back to login</Link>
              </div>

              <div style={{ marginTop: '20px', padding: '12px 14px', background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '10px', fontSize: '12px', color: '#1E40AF', lineHeight: 1.6 }}>
                PageConnect will never call or message asking for your password. If anyone does — it is a scam.
              </div>
            </>
          )}
        </div>
      </div>
      <style>{`@keyframes fp-spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}

export default ForgotPassword